import { createStore } from "vuex";
import VuexPersistence from "vuex-persist";

import BuyProcessStore from "./Modules/BuyProcessStore";
import SessionStore from "./Modules/SessionStore.js";
import GeneralConfigStore from "./Modules/GeneralConfigStore.js";
import ShoppingCarStore from "./Modules/ShoppingCarStore.js";

const persistence = new VuexPersistence({
  reducer: (state) => ({
    BuyProcessStore: state.BuyProcessStore,
    GeneralConfigStore: state.GeneralConfigStore,
    ShoppingCarStore: state.ShoppingCarStore,
  }),
});

export const store = createStore({
  plugins: [persistence.plugin],
  modules: {
    BuyProcessStore: BuyProcessStore,
    GeneralConfigStore: GeneralConfigStore,
    SessionStore: SessionStore,
    ShoppingCarStore: ShoppingCarStore,
  },
});
